import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const SKor2418Icon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "SKor2418IconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="18"
      viewBox="0 0 24 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <g clipPath="url(#clip0_1813_794)">
        <rect width="24" height="18" fill="white" />
        <g clipPath="url(#clip1_1813_794)">
          <path d="M0 0H24V18H0V0Z" fill="white" />
          <path
            d="M16.4952 3.79502L15.9333 4.16819L16.963 5.70569L17.5249 5.33252L16.4952 3.79502Z"
            fill="black"
          />
          <path
            d="M17.7131 5.61207L17.1512 5.98523L18.1809 7.52141L18.7428 7.14956L17.7131 5.61207Z"
            fill="black"
          />
          <path
            d="M17.3389 3.23572L16.7765 3.60876L19.0237 6.96294L19.5861 6.58991L17.3389 3.23572Z"
            fill="black"
          />
          <path
            d="M18.1794 2.67782L17.6182 3.05012L18.6481 4.58713L19.2093 4.21483L18.1794 2.67782Z"
            fill="black"
          />
          <path
            d="M19.3971 4.49427L18.8348 4.8673L19.8647 6.40431L20.427 6.03128L19.3971 4.49427Z"
            fill="black"
          />
          <path
            d="M5.82087 10.8762L5.25848 11.2492L7.50644 14.6045L8.06883 14.2314L5.82087 10.8762Z"
            fill="black"
          />
          <path
            d="M4.97633 11.436L4.41568 11.8082L5.44539 13.3457L6.00603 12.9732L4.97633 11.436Z"
            fill="black"
          />
          <path
            d="M6.19415 13.2521L5.63225 13.6253L6.66195 15.1628L7.22385 14.7896L6.19415 13.2521Z"
            fill="black"
          />
          <path
            d="M4.13414 11.9943L3.57283 12.3673L5.81904 15.7211L6.38137 15.348L4.13414 11.9943Z"
            fill="black"
          />
          <path
            d="M7.50613 3.79634L5.25853 7.15088L5.82043 7.52273L8.0667 4.16819L7.50613 3.79634Z"
            fill="black"
          />
          <path
            d="M6.66217 3.23708L4.41568 6.59047L4.97758 6.96364L7.22385 3.6091L6.66217 3.23708Z"
            fill="black"
          />
          <path
            d="M5.81878 2.67789L3.57317 6.03288L4.1357 6.40564L6.3813 3.05065L5.81878 2.67789Z"
            fill="black"
          />
          <path
            d="M16.963 12.6943L15.9333 14.2318L16.4952 14.605L17.5249 13.0675L16.963 12.6943Z"
            fill="black"
          />
          <path
            d="M18.1809 10.8773L17.15 12.414L17.7131 12.7879L18.7428 11.2504L18.1809 10.8773Z"
            fill="black"
          />
          <path
            d="M17.8059 13.2534L16.7761 14.7909L17.338 15.1623L18.3679 13.6251L17.8059 13.2534Z"
            fill="black"
          />
          <path
            d="M19.0237 11.4364L17.9937 12.9739L18.5559 13.3457L19.5856 11.8082L19.0237 11.4364Z"
            fill="black"
          />
          <path
            d="M18.6487 13.8112L17.619 15.3487L18.1808 15.7206L19.2106 14.1843L18.6487 13.8112Z"
            fill="black"
          />
          <path
            d="M19.8653 11.9969L18.8362 13.5345L19.3987 13.9073L20.4278 12.3697L19.8653 11.9969Z"
            fill="black"
          />
          <path
            d="M9.1905 9.75909C10.1208 10.3762 11.3785 10.127 12 9.2C12.6202 8.27302 13.8779 8.0238 14.8095 8.64091C15.7398 9.25802 15.9916 10.5094 15.3714 11.4364C16.6118 9.58372 16.1096 7.081 14.2476 5.84546C12.3856 4.60992 9.87035 5.11099 8.6286 6.96364C8.00839 7.89062 8.26019 9.14066 9.1905 9.75909Z"
            fill="#EF1A24"
          />
          <path
            d="M9.7524 12.5545C11.6144 13.7901 14.1297 13.289 15.3714 11.4364C15.9916 10.5094 15.7398 9.25802 14.8095 8.64091C13.8792 8.0238 12.6202 8.27302 12 9.2C11.3798 10.127 10.1221 10.3762 9.1905 9.75909C8.26019 9.14198 8.00839 7.89062 8.6286 6.96364C7.38818 8.81629 7.89045 11.319 9.7524 12.5545Z"
            fill="#004186"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_1813_794">
          <rect width="24" height="18" fill="white" />
        </clipPath>
        <clipPath id="clip1_1813_794">
          <rect width="24" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SKor2418Icon;
